"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var getSkusFromProductLinks = function getSkusFromProductLinks(productLinks) {
  var typeLink = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "upsell";
  return productLinks === null || productLinks === void 0 ? void 0 : productLinks.filter(function (productLink) {
    return productLink.linkType === typeLink;
  }).map(function (productLink) {
    return productLink.sku;
  }).toString();
};
var _default = getSkusFromProductLinks;
exports["default"] = _default;